import React from 'react';
import useCurrentTextStyle from '@src/hooks/useCurrentTextStyle';

export const ArticleReadTime = ({ article, settings, }) => {
  const { getCurrentTextStyle } = useCurrentTextStyle();

  const {
    colour_scheme,
    classes,
    time_style,
    time_style_mobile,
    time_style_tablet,
    time_style_ultrawide,
    time_style_enable_responsive,
    time_alignment = 'left',
    padding_top = 0,
    padding_right = 0,
    padding_bottom = 0,
    padding_left = 0,
    margin_top = 0,
    margin_right = 0,
    margin_bottom = 0,
    margin_left = 0
  } = settings;

  // Calculate read time if not provided
  const calculateReadTime = (content) => {
    if (!content) return null;
    
    // Strip HTML and count words
    const textContent = content.replace(/<[^>]*>/g, '');
    const words = textContent.split(' ').filter(word => word.length > 0).length;
    
    // Calculate read time (200 words per minute + 1 minute buffer)
    let readTime = Math.floor(words / 200) + 1;
    
    // Format time
    if (readTime > 60) {
      readTime = Math.round(readTime / 60);
      return `${readTime} hr`;
    } else {
      return `${readTime} min`;
    }
  };

  const readTime = article?.read_time || calculateReadTime(article?.content);

  // Do somehthing for description instead of excerpt
  if (!readTime) return null;

  return (
    <div 
      className={`
        w-full
        color-${colour_scheme}
        text-${time_alignment}
        pt-[${padding_top}px]
        pb-[${padding_bottom}px]
        pl-[${padding_left}px]
        pr-[${padding_right}px]
        mt-[${margin_top}px]
        mb-[${margin_bottom}px]
        ml-[${margin_left}px]
        mr-[${margin_right}px]
        ${classes}
      `}
    >
      <p className={getCurrentTextStyle(time_style, time_style_enable_responsive, time_style_mobile, time_style_tablet, time_style_ultrawide) || 'b1'}>{readTime}</p>
    </div>
  );
};